import React, { useEffect, useState } from "react";
import DashboardHeader from "../../../components/dashboardHeader";
import { useNavigate } from "react-router-dom";
import AppLoader from "../../../components/apploader";
import CustomContainer from "../../../components/container/CustomContainer";
import GlobalButton from "../../../components/button";
import { Stack } from "@mui/material";
import { useSelector } from "react-redux";
import { getAllUserPackage } from "../../../services/userPackageApiFn";
import { useSnackbar } from "../../../lib/context/snackbarContext";
import DynamicTable from "../../../components/table";
import { t } from "i18next";

const headerData = [
  "createdAt",
  "name",
  "category",
  "subCategory",
  "price",
  "totalOrders",
  "live",
  "order",
  "copyUrl",
];

const tableRows = [
  "date_time",
  "user_package",
  "user_package_category",
  "user_package_sub_category",
  "user_package_price",
  "totalOrders",
  "user_package_live",
  "user_package_order",
  "user_package_copy_url",
];

const UserEcommercePackagePage = () => {
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [allPackages, setAllPackages] = useState([]);
  const userData = useSelector((state) => state.userReducer.user);

  useEffect(() => {
    if (userData) {
      fetchAllUserPackages(userData?._id);
    }
  }, [userData]);

  const fetchAllUserPackages = async (value) => {
    try {
      setIsLoading(true);
      const response = await getAllUserPackage(value);
      if (response.data.status === "success") {
        let data = response.data.data;
        setAllPackages(data);
      }
    } catch (error) {
      showSnackbar(error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const renderHeader = () => {
    return (
      <Stack gap={2} direction={{ xs: "column", sm: "row" }}>
        <GlobalButton
          btnText={"createNewPackage"}
          handleClickBtn={() => navigate("/dashboard/ecommerce-package/create")}
          styleProps={{
            width: "auto",
            height: 40,
          }}
        />
      </Stack>
    );
  };

  const handleOrderPackage = (row, index) => {
    console.log(row, "HELLLO");
    navigate(`/check-out?package=${row?.packageUrl}`);
  };

  const handleCopyUrl = async (row) => {
    const url = `${window.location.origin}/package/${row?.packageUrl}?via=${userData?.referralCode}`;

    try {
      await navigator.clipboard.writeText(url);
      showSnackbar(t("referralUrlCopied"), "success");
    } catch (err) {
      console.error("Failed to copy: ", err);
      showSnackbar(t("failedToCopyUrl"), "error");
    }
  };

  return (
    <DashboardHeader>
      <AppLoader isVisible={isLoading} />
      <CustomContainer
        primaryHeading={t("ecommercePackage")}
        secondaryHeading={t("trackEcommercePackage")}
        showBackButton={true}
        handleBack={() => navigate("/dashboard")}
        // menuBarProps={renderMenuBar()}
        headProps={renderHeader()}
      >
        <DynamicTable
          tableHeader={headerData}
          displayRows={tableRows}
          tableData={allPackages}
          handleOrderPackage={handleOrderPackage}
          handleCopyUrl={handleCopyUrl}
        />
      </CustomContainer>
    </DashboardHeader>
  );
};

export default UserEcommercePackagePage;
